import { getPermissions, UserPermissions } from '@creditsights/api-ui-web';
import { useQuery, UseQueryResult } from 'react-query';
import { USER_PERMISSIONS_CACHE_KEY } from '../../Constants';

export default (): UseQueryResult<UserPermissions> => useQuery<UserPermissions, Error>([USER_PERMISSIONS_CACHE_KEY], async () => getPermissions());
